module.exports = __webpack_public_path__ + "static/img/IT.21bc5fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/IT.svg
// module id = bQuo
// module chunks = 66